import {QueryFunctionContext} from 'react-query';
import request from 'services/axios';

export const getPostChart = async (ctx: QueryFunctionContext) => {
  const {data}: {data: Array<IGetPostChart>} = await request.get(
    `/api/v2/market/post-views?post_guid=${ctx.queryKey[1]}`,
  );
  return data;
};
